import Image from "next/image";
import Link from "next/link";
import { baseURL } from "../categories/categoryItem";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import { useState } from "react";
// https://api.impactoverse.com/api/app/list-assets?limit=75&offset=0&isSold=false&priceMin=0&priceMax=100000000000000000&percentageMin=0&percentageMax=100&impactCategory=&nftCategory=&username=&itemName=

const ImpactGridItems = ({ assetsList }) => {
  const dispatch = useDispatch();
  const router = useRouter();

  return (
    <>
      {!!assetsList?.length &&
        assetsList.map((item, index) => (
          <article key={item._id} className="group relative">
            <div className="bg-white dark:bg-jacarta-700 rounded-2xl border border-jacarta-100 dark:border-jacarta-600 transition-all duration-300 hover:shadow-xl hover:border-accent/50 dark:hover:border-accent/50 overflow-hidden">
              {/* Image Container - Better proportions */}
              <figure className="relative overflow-hidden bg-jacarta-50 dark:bg-jacarta-600 aspect-[5/4]">
                <Link href={`/marketplace/${item._id}`}>
                  <Image
                    width={300}
                    height={240}
                    src={baseURL + item.imageUrl}
                    alt={item.itemName}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </Link>
              </figure>

              {/* Content Section - More spacious */}
              <div className="p-5 space-y-4">
                {/* Title */}
                <Link
                  href={`/marketplace/${item._id}`}
                  className="block group/title"
                >
                  <h3 className="font-semibold text-lg text-jacarta-700 dark:text-white group-hover/title:text-accent transition-colors duration-200 line-clamp-2 leading-relaxed">
                    {item.itemName}
                  </h3>
                </Link>

                {/* Creator Badge */}
                {item.creator && (
                  <div className="flex items-center gap-3">
                    <div className="relative">
                      {item.creator.avatarUrl ? (
                        <img
                          src={`${baseURL}${item.creator.avatarUrl}`}
                          alt={item.creator.username || "Creator"}
                          className="w-6 h-6 rounded-full object-cover"
                          onError={(e) => {
                            console.log(
                              "Grid avatar failed to load:",
                              `${baseURL}${item.creator.avatarUrl}`,
                            );
                            e.target.style.display = "none";
                            e.target.nextSibling.style.display = "flex";
                          }}
                        />
                      ) : null}
                      <div
                        className={`w-6 h-6 bg-accent rounded-full flex items-center justify-center flex-shrink-0 ${item.creator.avatarUrl ? "hidden" : "flex"}`}
                      >
                        <span className="text-white text-xs font-bold">
                          {item.creator.username
                            ? item.creator.username.charAt(0).toUpperCase()
                            : "U"}
                        </span>
                      </div>
                    </div>
                    <p
                      className="text-sm text-jacarta-500 dark:text-jacarta-400 truncate flex-1"
                      title={item.creator.username}
                    >
                      {item.creator.username || "Unknown Creator"}
                    </p>
                  </div>
                )}

                {/* Price and Action */}
                <div className="flex items-center justify-between pt-3 border-t border-jacarta-100 dark:border-jacarta-600">
                  <div>
                    <p className="text-xs text-jacarta-500 dark:text-jacarta-400 mb-1.5">
                      Price
                    </p>
                    <p className="text-xl font-bold text-accent">
                      ${Math.round(item.priceUsd)}
                    </p>
                  </div>
                  <button
                    className="bg-accent hover:bg-accent-dark text-white font-medium py-2.5 px-5 rounded-lg transition-all duration-200 hover:shadow-md focus:outline-none focus:ring-2 focus:ring-accent/50"
                    onClick={(e) => {
                      // The real checkout lives on the detail page — the old
                      // buy modal was an empty shell with no purchase action.
                      e.preventDefault();
                      router.push(`/marketplace/${item._id}`);
                    }}
                  >
                    <span className="text-sm">BUY NOW</span>
                  </button>
                </div>
              </div>
            </div>
          </article>
        ))}
    </>
  );
};

export default ImpactGridItems;
